
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import { useRecoilState } from 'recoil';
import { isNil } from 'lodash';

// ATOM
import {categoryAtom, inventoryAtom} from 'Recoil/inventory.atom';

// SERVICE
import {fetchCategoryList, fetchProductList} from 'Services/inventory.services';

// HELPER
import { encode, decode } from 'Helpers/enc';

// ANT COMPONENT
import { Grid } from 'antd';

// HOOK
import useQuery from 'Hooks/query.hook';

// COMPONENT
import ProductCatalog from "Components/product-catalog";

// STYLE
import './product-catalog.scss';

const ProductCatalogPage = () => {
  const history = useHistory();
  const query = useQuery();
  const { t } = useTranslation();

  const name: any = query.get('name');
  const category: any = query.get('category');
  const category2: any = query.get('category2');

  const [inventoryState, setInventoryState] = useRecoilState<any>(inventoryAtom);
  const [categoryState, setCategoryState] = useRecoilState<any>(categoryAtom);
  const categoryID = decode(category)
  const category2ID = decode(category2)

  const isLoading = inventoryState.status.fetch === 'loading';

  useEffect(() => {
    fetchProducts();
  },[category,category2])

  useEffect(() => {
    fetchCategories();
  },[category])

  const fetchProducts = async () => {
    setInventoryState({
      ...inventoryState,
      status: { ...inventoryState.status, fetch: 'loading' }
    });

    const filters = { active: true, categoryIDs: [categoryID] };
    const pagination = { offset: 0, limit: 20 };

    if(category2ID){
      filters.categoryIDs= [category2ID]
    }

    const responseData = await fetchProductList(filters, pagination, { sortBy: 'createdAt', mode: 'ASC' });

    if (!isNil(responseData)) {
      setInventoryState({
        ...inventoryState,
        status: { ...inventoryState.status, fetch: 'success' },
        list: responseData
      });
    }
    else {
      setInventoryState({
        ...inventoryState,
        status: { ...inventoryState.status, fetch: 'error' }
      });
    }
  }

  const fetchCategories = async () => {
    setCategoryState({
      ...categoryState,
      status: { ...categoryState.status, fetch: 'loading' }
    });

    const responseData = await fetchCategoryList({ parent: categoryID, active: true });
    if (!isNil(responseData)) {
      setCategoryState({
        ...categoryState,
        status: { ...categoryState.status, fetch: 'success' },
        list: responseData
      });
    }
    else {
      setCategoryState({
        ...categoryState,
        status: { ...categoryState.status, fetch: 'error' }
      });
    }
  }

  const handleCategorySelect = (data: any) => {
    history.push(`/products/catalog/list?name=${name}&category=${category}&category2=${encode(data._id)}&subName=${encode(data.name)}`);
  }

  const handleMainCategorySelect = () => {
    history.push(`/products/catalog/list?name=${name}&category=${category}`)
  }

  return (
    <div>
      <div className="gradient-bg" />

      <div className="product-catalog--container">
      {/* <div className="product-catalog--gradient-bg"/> */}

        <div className="p-20 m-20 page--container product-catalog--page">
          <ProductCatalog
            isLoading={isLoading}
            products={inventoryState.list}
            categories={categoryState.list}
            onCategorySelect={handleCategorySelect}
            onMainCategorySelect={handleMainCategorySelect}
          />
        </div>
      </div>
    </div>
  )
}

export default ProductCatalogPage
